import { useState } from 'react';
import LiftingWorkout from './LiftingWorkout';
import LiftingTemplates from './LiftingTemplates';
import LiftingHistory from './LiftingHistory';
import LiftingDashboard from './LiftingDashboard';

const TABS = [
  { key: 'workout', label: 'Workout' },
  { key: 'templates', label: 'Templates' },
  { key: 'history', label: 'History & Stats' },
  { key: 'dashboard', label: 'Dashboard' },
];

function LiftingModule({ getToken, userEmail }) {
  const [tab, setTab] = useState('workout');

  return (
    <div className="Swimming">
      <div className="Swimming-tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`Swimming-tab${tab === t.key ? ' Swimming-tab--active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'workout' && <LiftingWorkout getToken={getToken} userEmail={userEmail} />}
      {tab === 'templates' && <LiftingTemplates getToken={getToken} userEmail={userEmail} />}
      {tab === 'history' && <LiftingHistory getToken={getToken} userEmail={userEmail} />}
      {tab === 'dashboard' && <LiftingDashboard getToken={getToken} userEmail={userEmail} />}
    </div>
  );
}

export default LiftingModule;
